<script setup lang="ts">
import type { PropType } from "vue";
import type { Collection } from "~/types";
import { getThumbnailImage } from "~/utils/common";
import VideoCallToAction from "~/components/Video/VideoCallToAction.vue";
import { useProcessStore } from "~/stores/process/store";

const route = useRoute();

const processStore = useProcessStore();

defineProps({
  video: {
    type: Object as PropType<Collection & { onAir: boolean }>,
    required: true,
  },
});

function actionBtnClicked(action: string) {
  processStore.setRedirectUrl(route.fullPath);
}
</script>

<template>
  <div class="relative h-screen w-full overflow-hidden">
    <div class="absolute inset-0 z-10 bg-black/80" />
    <div
      class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      :style="{
        backgroundImage: `url(${getThumbnailImage([video.pre_air_images, video.images])})`,
      }"
    />

    <div
      class="absolute z-20 flex h-screen w-full flex-col items-center justify-center"
    >
      <VideoCallToAction
        class="absolute z-20 mt-0 w-full items-center justify-center"
        :video="video"
        @action-btn-clicked="actionBtnClicked"
      />
    </div>
  </div>
</template>

<style scoped></style>
